import React from 'react';
import { ContactTable } from '../ContactTable';
import { Container } from 'reactstrap';
import Page from '../Page';
import './style.css';

export const Contact = ({ innerWidth }) => {
  const flexDirection = innerWidth >= 770 ? 'flex-row' : 'flex-column-reverse';
  const alignItems = innerWidth >= 770 ? 'start' : 'center';
  const textSize = innerWidth < 515 ? 'small' : '';

  return (
    <Page
      id='contact'
      title='Contact'
      className='pt-5 contact'
      description='Contact and scheduling information for Interconnections Counseling'>
      <Container>
        <h2>Scheduling</h2>
        <p>
          We see clients virtually through a secure telehealth platform.
          Please call to ask about current availability or to schedule your next
          appointment.
        </p>
        <p>
          If you need to reschedule, please contact your counselor directly by
          phone.
        </p>
        <p>
          For all other inquiries, please{' '}
          <a
            href='mailto:info@interconnectionscounseling.com'
            aria-label='link to send email to interconnections counseling'>
            send us an email.
          </a>
        </p>
      </Container>
      <section
        className={`d-flex justify-content-around align-items-${alignItems} ${flexDirection} ${textSize} p-3 bg-white`}>
        <div className='mt-2'>
          <ContactTable />
        </div>
      </section>
    </Page>
  );
};

export default Contact;
